import { render, staticRenderFns } from "./View.vue?vue&type=template&id=09ea5e01"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09ea5e01')) {
      api.createRecord('09ea5e01', component.options)
    } else {
      api.reload('09ea5e01', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=09ea5e01", function () {
      api.rerender('09ea5e01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/ui-components/pcspacing/View.vue"
export default component.exports